import { Component, OnInit } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html'
})
export class YesNoComponent implements OnInit {

  data: any
  typeYes:boolean = true

  constructor(private modal: NgxSmartModalComponent) { }

  ngOnInit() {
    this.data = this.modal.getData()
    this.typeYes = !this.data.typeInfo
  }

  clickYes() {
    this.data.result = "YES"
    this.modal.setData(this.data, true)
    this.modal.close();
  }
  
  clickNo() {
    this.data.result = "NO"
    this.modal.setData(this.data,true)
    this.modal.close();
  }

}
